export default "__VITE_ASSET__BLUPcNSX__"